import { render } from "./ImprovedChemicalStructureViewer.vue?vue&type=template&id=c37b3822&scoped=true"
import script from "./ImprovedChemicalStructureViewer.vue?vue&type=script&lang=js"
export * from "./ImprovedChemicalStructureViewer.vue?vue&type=script&lang=js"

import "./ImprovedChemicalStructureViewer.vue?vue&type=style&index=0&id=c37b3822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37b3822"]])

export default __exports__